.list {
  display: flex;
  gap: 12px;
  align-items: center;
  overflow-x: auto;
}

.list::-webkit-scrollbar {
  display: none;
}

.pressReleaseRoot {
  @container press-release-root (min-width: 1024px) {
    max-width: 1126px;
    margin-right: auto;
    margin-left: auto;
  }
}

.screen {
  @media screen and (width >= 1024px) {
    max-width: 1126px;
    margin-right: auto;
    margin-left: auto;
  }
}
